import type { PoisonQueueMessage } from '@urbanx/agx.support.client';
import { AgxTypography } from '@urbanx/agx.ui-components2';
import dayjs from 'dayjs';
import { formatMessageBody } from './messageFilters';

export function messageRows(messages: PoisonQueueMessage[]) {
  return messages.map((msg) => ({
    Id: (
      <AgxTypography type={'body_ui'} size={'small'}>
        <pre
          style={{
            fontSize: 'inherit',
            fontFamily: 'inherit',
          }}
        >
          {msg.id ?? '-'}
        </pre>
      </AgxTypography>
    ),
    'Inserted At': (
      <AgxTypography type={'body_ui'} size={'small'}>
        <pre
          style={{
            fontSize: 'inherit',
            fontFamily: 'inherit',
          }}
        >
          {!msg.insertionTime ? '-' : dayjs(msg.insertionTime).format('DD/MM/YYYY h:mm A')}
        </pre>
      </AgxTypography>
    ),
    'Message Body': (
      <AgxTypography type={'body_ui'} size={'small'}>
        <pre
          style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            overflow: 'hidden',
            WebkitLineClamp: 10,
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            fontSize: 'inherit',
            fontFamily: 'inherit',
          }}
        >
          {formatMessageBody(msg.messageBodyJson)}
        </pre>
      </AgxTypography>
    ),
  }));
}
